import { LINK_ALLOWED_PROTOCOLS, SIMPLE_EMAIL_REGEX } from "@/src/shared/constants";

const SECURE_WINDOW_FEATURES = "noopener,noreferrer";

export const getSafeUrl = (targetUrl?: string | null): string | null => {
  const normalizedTargetUrl = targetUrl?.trim();
  if (!normalizedTargetUrl) return null;

  try {
    const url = new URL(normalizedTargetUrl, window.location.origin);
    if (!LINK_ALLOWED_PROTOCOLS.includes(url.protocol)) return null;

    return url.toString();
  } catch {
    return null;
  }
};

export const getSafeMailtoUrl = (email?: string | null): string | null => {
  if (!email) return null;

  const trimmedEmail = email.trim();
  if (!SIMPLE_EMAIL_REGEX.test(trimmedEmail)) return null;
  return `mailto:${trimmedEmail}`;
};

export const openUrlInNewTab = (targetUrl?: string | null): Window | null => {
  const safeUrl = getSafeUrl(targetUrl);
  if (!safeUrl) return null;

  return window.open(safeUrl, "_blank", SECURE_WINDOW_FEATURES);
};

export const redirectToUrl = (targetUrl?: string | null): void => {
  const safeUrl = getSafeUrl(targetUrl);

  if (!safeUrl) return;
  window.location.assign(safeUrl);
};

export const redirectToMailto = (email?: string | null): void => {
  const safeUrl = getSafeMailtoUrl(email);

  if (!safeUrl) return;
  window.location.assign(safeUrl);
};
